import React from 'react';
import { SimpleGrid, Box, Stat, StatLabel, StatNumber, StatHelpText, Icon, Flex, Text, Skeleton } from '@chakra-ui/react';
import { FaTicketAlt, FaUserClock, FaExclamationTriangle, FaPlusCircle } from 'react-icons/fa';

const TicketDashboard = ({ stats, loading }) => {
    const statusOrder = ['aberto', 'em_andamento', 'bloqueado', 'fechado'];
    const statusColors = { aberto: 'blue.500', em_andamento: 'orange.500', bloqueado: 'purple.500', fechado: 'green.500' };
    const statusLabels = { aberto: 'Aberto', em_andamento: 'Em Andamento', bloqueado: 'Bloqueado', fechado: 'Concluido' };

    const StatCard = ({ icon, label, value, helpText, gradient }) => (
        <Stat
            p={4}
            shadow="sm"
            borderWidth="1px"
            borderRadius="lg"
            bgGradient={gradient}
            color="white"
            position="relative"
            overflow="hidden"
            minH="120px"
        >
            <Icon as={icon} boxSize="80px" color="whiteAlpha.200" position="absolute" top={-2} right={-2} transform="rotate(-15deg)" />
            <Flex direction="column" h="100%">
                <StatLabel fontWeight="bold" fontSize="sm">{label}</StatLabel>
                <Skeleton isLoaded={!loading} startColor="whiteAlpha.100" endColor="whiteAlpha.400" h="36px" w="80px" my="1">
                    <StatNumber fontSize="3xl" fontWeight="extrabold">{value ?? 0}</StatNumber>
                </Skeleton>
                <StatHelpText color="whiteAlpha.800" mt="auto" fontSize="xs">{helpText}</StatHelpText>
            </Flex>
        </Stat>
    );

    return (
        <Box mb={4}>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4}>
                <StatCard
                    icon={FaUserClock}
                    label="Atribuídos a Mim"
                    value={stats?.assigned_to_me}
                    helpText="Tickets ativos"
                    gradient="linear(to-br, blue.500, blue.400)"
                />
                <StatCard
                    icon={FaPlusCircle}
                    label="Novos Hoje"
                    value={stats?.new_today}
                    helpText={`Abertos nas últimas 24h: ${stats?.new_last_24h ?? 0}`}
                    gradient="linear(to-br, green.500, green.400)"
                />
                <StatCard
                    icon={FaExclamationTriangle}
                    label="Urgentes"
                    value={stats?.urgent}
                    helpText="Prioridade máxima"
                    gradient="linear(to-br, red.600, red.500)"
                />
                <StatCard
                    icon={FaTicketAlt}
                    label="Total de Tickets"
                    value={stats?.total}
                    helpText="Incluindo todos os status"
                    gradient="linear(to-br, gray.600, gray.500)"
                />
            </SimpleGrid>

            <Box mt={4} p={4} shadow="sm" borderWidth="1px" borderRadius="lg" bg="white">
                <SimpleGrid columns={{ base: 2, md: 4 }} spacing={4}>
                    {statusOrder.map(status => (
                        <Flex key={status} align="center" p={3} borderRadius="md" borderWidth="1px" bg={`${statusColors[status].split('.')[0]}.50`}>
                            <Box w={2} h={2} borderRadius="full" bg={statusColors[status]} mr={3}></Box>
                            <Box>
                                <Text fontSize="sm" color="gray.600">{statusLabels[status] || status}</Text>
                                <Skeleton isLoaded={!loading} h="28px" minW="40px">
                                    <Text fontWeight="bold" fontSize="xl" whiteSpace="nowrap">{stats?.[`status_${status}`] ?? 0}</Text>
                                </Skeleton>
                            </Box>
                        </Flex>
                    ))}
                </SimpleGrid>
            </Box>
        </Box>
    );
};

export default TicketDashboard;